import React from 'react';

const AssessmentAp = () => null;

export default AssessmentAp;
